<template>
  <div class="match-expert wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">论文信息</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">学校</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">学号</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">姓名</div></th>
              <th><div class="kh-table-cell">一级学科</div></th>
              <th><div class="kh-table-cell">二级学科</div></th>
              <th><div class="kh-table-cell">论文涉及研究方向</div></th>
              <th><div class="kh-table-cell">论文题目</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">送审专家数</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">单位提交时间</div></th>
              <th v-if="from!=='unit'"><div class="kh-table-cell">送审专家数操作</div></th>
            </tr>
            </thead>
            <tbody>
            <tr class="kh-table-row">
              <td><div class="kh-table-cell">{{studentMsg.unitName}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.schoolNo}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.authorName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.firstSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.secondSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.researchAera}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.titleCn}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.sendNum + '/' + studentMsg.auditExpertNum}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.submitTime}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">
                <span class="link-a" @click="showUpdateExpertNum">修改</span>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">已送专家</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">姓名</div></th>
              <th><div class="kh-table-cell">导师类型</div></th>
              <th><div class="kh-table-cell">技术职务</div></th>
              <th><div class="kh-table-cell">单位</div></th>
              <th><div class="kh-table-cell">一级学科</div></th>
              <th><div class="kh-table-cell">二级学科</div></th>
              <th><div class="kh-table-cell">专业学位</div></th>
              <th><div class="kh-table-cell">专业领域</div></th>
              <th><div class="kh-table-cell">联系电话</div></th>
              <th><div class="kh-table-cell">邮箱</div></th>
              <th><div class="kh-table-cell">操作</div></th>
            </tr>
            </thead>
            <tbody>
            <tr class="kh-table-row" v-for="(expert,index) in acceptExpertList" :key="expert.id+'-number'+index">
              <td><div class="kh-table-cell"><span class="link-span" @click="displayExpertMessage(expert)">{{expert.name}}</span></div></td>
              <td><div class="kh-table-cell">{{typeMap[expert.acTutorType]}}</div></td>
              <td><div class="kh-table-cell">{{positionMap[Number(expert.techPosition)]}}</div></td>
              <td><div class="kh-table-cell">{{expert.orgName}}</div></td>
              <td><div class="kh-table-cell">{{expert.mFirstSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{expert.mSecondSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{expert.degreeCategoryName}}</div></td>
              <td><div class="kh-table-cell">{{expert.degreeDomainName}}</div></td>
              <td><div class="kh-table-cell">{{expert.phone}}</div></td>
              <td><div class="kh-table-cell">{{expert.email1}}</div></td>
              <td><div class="kh-table-cell">
                <span v-if="(expert.reviewStatus!=='2')" class="link-a" @click="fetchDetail(expert.expReviewId)">详情</span>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="wrap-form" v-if="!readonly && from!=='unit'">
        <label class="form-label">可送专家<span @click="setDeatultExpertParam" style="margin-left: 20px;" class="kh-btn kh-btn-primary">匹配专业</span></label>
        <div class="">
          <regular-page ref="sendExpertPage"
                        v-if="!loading"
                        config-path="sendExpert"
                        :default-query="defaultParam"
                        :parent-id="currentId"
                        @reload="fetchDefaultMessage"
          ></regular-page>
        </div>
      </div>
      <div class="wrap-form" v-if="!readonly && from==='unit'">
        <label class="form-label">可送专家<span @click="setDeatultExpertParam" style="margin-left: 20px;" class="kh-btn kh-btn-primary">匹配专业</span><span class="tips color-blue" @click="expert.show = true">找不到专家？点此新增专家</span></label>
        <div class="">
          <regular-page ref="sendExpertPage"
                        v-if="!loading"
                        config-path="sendExpertFromUnit"
                        :default-query="defaultParam"
                        :parent-id="currentId"
                        @reload="fetchDefaultMessage"
          ></regular-page>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">已送单位</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">单位名称</div></th>
              <th><div class="kh-table-cell">学院</div></th>
              <th><div class="kh-table-cell">联系人</div></th>
              <th><div class="kh-table-cell">联系电话</div></th>
              <th><div class="kh-table-cell">专家费</div></th>
              <th><div class="kh-table-cell">管理费</div></th>
              <th><div class="kh-table-cell">操作</div></th>
            </tr>
            </thead>
            <tbody>
            <tr class="kh-table-row" v-for="(unit, index) in acceptUnit" :key="index">
              <td><div class="kh-table-cell">{{unit.schoolName}}</div></td>
              <td><div class="kh-table-cell">{{unit.department}}</div></td>
              <td><div class="kh-table-cell">{{unit.name}}</div></td>
              <td><div class="kh-table-cell">{{unit.mobile}}</div></td>
              <td><div class="kh-table-cell">{{unit.expertFee}}</div></td>
              <td><div class="kh-table-cell">{{unit.manageFee}}</div></td>
              <td><div class="kh-table-cell">
                <span class="link-a" @click="fetchDetail(unit.expReviewId)">详情</span>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">下载附件</label>
        <div style="display:flex">
          <p v-if="studentMsg.paperFileId">
            <span>论文原文下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(studentMsg.paperFileId)"/>
          </p>
          <p style="margin-left:30px" v-if="studentMsg.absFileId">
            <span>摘要下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(studentMsg.absFileId)"/>
          </p>
          <p style="margin-left:30px" v-if="studentMsg.biFileId">
            <span>简况表下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(studentMsg.biFileId)"/>
          </p>
          <p style="margin-left:30px" v-if="studentMsg.srFileId">
            <span>自评表下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(studentMsg.srFileId)"/>
          </p>
        </div>
      </div>
      <Modal v-model="expert.show"
            title="新增专家"
            width="800"
            @on-ok="dialogOK"
            :loading="expert.loading"
      >
        <expert-message ref="expertEdit" v-if="expert.show" :parent-id="currentId"></expert-message>
      </Modal>
      <Modal v-model="expertDialogConfig.show"
            title="专家信息"
            width="800"
            :footer-hide="true">
        <expert-message v-if="expertDialogConfig.show"
                        :query="expertDialogConfig.expertId+'&readonly'">
        </expert-message>
      </Modal>

      <Modal v-model="expertNumConfig.show"
            @on-ok="confirmExpertNum"
            width="340"
            title="送审专家数修改">
        <Form label-position="left" :label-width="0">
          <FormItem>
            <InputNumber :min="0" v-model="expertNumConfig.num" style="width: 100%;"></InputNumber>
          </FormItem>
        </Form>
      </Modal>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
    <Modal v-model="assignDialogConfig.show"
        title="指派记录"
        width="1200"
        @on-ok="dialogOK"
        :loading="assignDialogConfig.loading"
      >
      <assigned-record ref="expertEdit" v-if="assignDialogConfig.show" :parent-id="detailId"></assigned-record>
    </Modal>
    <div class="g-ta-c">
      <Button type="default" @click="back" class="save">返回</Button>
    </div>
  </div>
</template>

<script>
import regularPage from '../../regularPage'
import expertMessage from '../../dialogs/systemManage/unitExpertEdit'
import assignedRecord from '../../dialogs/thesisManage/assignedRecord'
export default {
  name: 'matchExpert',
  components: {regularPage, expertMessage, assignedRecord},
  props: {
    query: ''
  },
  data () {
    return {
      identity: 0,
      from: '',
      currentId: '',
      defaultParam: {},
      readonly: false,
      studentMsg: {},
      acceptExpertList: {},
      typeMap: {
        0: '其他',
        1: '博士生导师',
        2: '硕士生导师',
        3: '兼职博士生导师',
        4: '兼职硕士生导师',
        5: '行业导师'
      },
      positionMap: {
        '00': '无',
        '01': '初级',
        '02': '中级',
        '03': '副高级',
        '04': '正高级',
        '05': '讲师(博士学位)',
        '06': '副教授',
        '07': '教授'
      },
      expert: {
        show: false,
        loading: false
      },
      expertDialogConfig: {
        show: false,
        expertId: ''
      },
      expertNumConfig: {
        show: false,
        num: 0
      },
      loading: true,
      acceptUnit: [],
      assignDialogConfig: {
        show: false,
        loading: false
      },
      detailId: '',
      detailList: []
    }
  },
  created () {
    this.identity = this.$store.state.role.identity;
    this.currentId = this.query.split('&')[0].split('id=')[1] || this.$route.query.id;
    this.readonly = this.query.includes('readonly');
    this.from = this.query.split('from=')[1] || this.$route.query.from;
    this.fetchDefaultMessage();
  },
  watch: {
  },
  methods: {
    fetchDetail (id) {
      this.detailId = id
      this.assignDialogConfig.show = true
      // const temp = {
      //   page: {currPage: 1, pageSize: 2000},
      //   query: {reviewId: id}
      // }
      // this.post(`exp/expReviewFlow/queryExpReviewFlowDTOPage`, temp).then(res => {
      //   this.detailList = res.data.list
      // })
    },
    fetchDefaultMessage () {
      const _self = this;
      _self.loading = true;
      let url = '/custom/sendPaper/getPaperDetail/';
      // if (_self.from === 'unit') {
      //   url = '/school/schoolDegreeOffice/info/';
      // }
      _self.post(url + _self.currentId).then(res => {
        _self.studentMsg = res.data;
        _self.acceptExpertList = res.data.expDTOList || (res.data.exp ? [res.data.exp] : []);
        _self.acceptUnit = res.data.receiveUnitList
        // _self.defaultParam = {
        //   mFirstSubjectName: _self.studentMsg.firstSubjectName,
        //   mSecondSubjectName: _self.studentMsg.secondSubjectName
        // }

        _self.loading = false;
      }).catch(() => {
        _self.loading = false;
      });
    },
    setDeatultExpertParam () {
      const _self = this;
      _self.defaultParam = {
        mFirstSubjectName: _self.studentMsg.firstSubjectName,
        mSecondSubjectName: _self.studentMsg.secondSubjectName
      }
      _self.$nextTick(function () {
        _self.$refs['sendExpertPage'].refresh();
        _self.defaultParam = {};
      })
    },
    displayExpertMessage (expert) {
      this.expertDialogConfig.expertId = expert.id;
      this.expertDialogConfig.show = true;
    },
    // 发送请求取消评审
    requestCancelSend (expert) {
      let url = '/custom/sendPaper/delete';
      let param = {};
      if (this.from === 'unit') {
        url = '/school/schoolDegreeOffice/deleteSendExpert';
        param = {id: this.studentMsg.expReviewId};
      } else {
        param = {id: expert.expReviewInfoId, paperId: this.currentId};
      }
      this.post(url, param).then(res => {
        this.$Message.success('取消成功！');
        this.fetchDefaultMessage();
      })
    },
    // 重置评阅
    resetReviewStatus (expert) {
      const _self = this;
      _self.fetch('/exp/expReviewInfo/openReview/' + expert.expReviewInfoId).then(res => {
        this.$Message.success('重置成功！');
        this.fetchDefaultMessage();
      });
    },
    showUpdateExpertNum () {
      const _self = this;
      _self.expertNumConfig.num = _self.studentMsg.auditExpertNum;
      _self.expertNumConfig.show = true;
    },
    confirmExpertNum () {
      const _self = this;
      _self.$Modal.confirm({
        title: '提示',
        width: 340,
        content: '是否确定将送审专家数量修改为 ' + _self.expertNumConfig.num + ' ?',
        onOk: function () {
          _self.post('/custom/sendPaper/updateExpNum', {id: _self.studentMsg.id, auditExpertNum: _self.expertNumConfig.num}).then(res => {
            _self.$Message.success(res.msg);
            _self.fetchDefaultMessage();
          })
        }
      })
    },
    dialogOK () {
      const _self = this;
      _self.$refs['expertEdit'].dialogComfirm().then(val => {
        _self.$refs['sendExpertPage'].reload();
        _self.expert.show = false;
        // // 发送指派请求
        // _self.post('/school/schoolDegreeOffice/relate', {id: _self.currentId, expId: val.id}).then(res => {
        //   _self.$Message.success(res.msg);
        //   // 确定成功后重刷页面
        //   _self.fetchDefaultMessage();
        // });
      }).catch((error) => {
        if (error.code === 500) {
          _self.expert.show = false;
          _self.fetchDefaultMessage();
        } else {
          _self.expert.loading = false;
          _self.$nextTick(function () {
            _self.expert.loading = true;
          })
        }
      });
    },
    back () {
      this.$emit('back');
    },
    handleDown (value) {
      this.fetch(`/paper/fileInfo/downloadFile/` + value).then(res => {
        if (res.code === 200) {
          setTimeout(function () {
            window.open(res.data);
          }, 1);
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .match-expert {
    .kh-table {
      table {
        table-layout: auto;
        width: 100%;
        th {
          border-top: 1px solid #e8eaec;
          .kh-table-cell {
            white-space: nowrap;
          }
          &:first-child {
            border-left: 1px solid #e8eaec;
          }
        }
        td {
          &:first-child {
            border-left: 1px solid #e8eaec;
          }
        }
        .link-span {
          cursor: pointer;
          text-decoration: underline;
        }
        .link-a {
          color: @link-color;
          cursor: pointer;
        }
      }
    }
    .form-label {
      .tips {
        color: #9ea7b4;
        font-size: @font-size-small;
        font-weight: normal;
        &.color-blue {
          color: @base-color;
          cursor: pointer;
          margin-left: 20px;
        }
      }
    }
    .text-down {
      font-size: 25px;
      color: #1890FF;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/matchExpert.vue